var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { DriveUrlsService } from '../drive-urls.service';
import { DriveState } from '../state/drive-state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OpenFolder } from '../state/actions/commands';
import { ROOT_FOLDER } from '../folders/root-folder';
var SidebarComponent = /** @class */ (function () {
    function SidebarComponent(urls, store) {
        this.urls = urls;
        this.store = store;
    }
    SidebarComponent.prototype.openFolder = function (folder) {
        this.store.dispatch(new OpenFolder(folder));
    };
    SidebarComponent.prototype.getRootFolder = function () {
        return ROOT_FOLDER;
    };
    __decorate([
        Select(DriveState.activePage),
        __metadata("design:type", Observable)
    ], SidebarComponent.prototype, "activePage$", void 0);
    return SidebarComponent;
}());
export { SidebarComponent };
